

<template>
  <div>
    <div class="tools">
      <div class="button">
        <bk-button
          :theme="'default'"
          type="submit"
          :title="'基础按钮'"
          @click.stop="prePage"
          class="mr10"
        >
          <el-button type="success">上一页</el-button></bk-button
        >
        <div class="page">{{ pageNum }}/{{ pageTotalNum }}</div>
        <bk-button
          :theme="'default'"
          type="submit"
          :title="'基础按钮'"
          @click.stop="nextPage"
          class="mr10"
          ><el-button type="success">下一页</el-button></bk-button
        >
      </div>
    </div>

    <!-- <pdf
      v-for="i in numPages"
      :key="i"
      :src="src"
      :page="i"
      style="width: 100%"
    ></pdf> -->
    <pdf
      ref="wrapper"
      :src="url"
      :page="pageNum"
      :rotate="pageRotate"
      @progress="loadedRatio = $event"
      @page-loaded="pageLoaded($event)"
      @num-pages="pageTotalNum = $event"
      @error="pdfError($event)"
      @link-clicked="page = $event"
    >
    </pdf>

    <!-- <div>
			<li :class="{select:idx==0}" @touchstart="idx=0" @touchend="idx=-1" @click="scaleD">
        <p class="more-p">放大</p>
      </li>
      <li :class="{select:idx==1}" @touchstart="idx=1" @touchend="idx=-1" @click="scaleX">
        <p class="small-p">缩小</p>
      </li>
		</div> -->
    <div class="button">
      <div class="icon-button-a">
        <div @click="scaleD">
          <img class="icon-button" src="../../images/icon/da.png" alt="" />
        </div>
        <div @click="scaleX">
          <img class="icon-button" src="../../images/icon/xiao.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import pdf from "vue-pdf";
import util from "../../common/util";
export default {
  name: "Home",
  components: {
    pdf,
  },
  data() {
    return {
      url: this.$route.query.url,
      pageNum: 1,
      pageTotalNum: 1,
      pageRotate: 0,
      // 加载进度
      loadedRatio: 0,
      curPageNum: 0,
      scale: 100,
      src: "",
      numPages: undefined,
    };
  },
  mounted: function () {
    util.hideLoading();
  },
  methods: {
    // 上一页函数，
    prePage() {
      if (this.pageNum == 1) {
        return false;
      }
      var page = this.pageNum;
      page = page > 1 ? page - 1 : this.pageTotalNum;
      this.pageNum = page;
    },
    // 下一页函数
    nextPage() {
      if (this.pageNum == this.pageTotalNum) {
        return false;
      }
      var page = this.pageNum;
      page = page < this.pageTotalNum ? page + 1 : 1;
      this.pageNum = page;
    },
    // 页面顺时针翻转90度。
    clock() {
      this.pageRotate += 90;
    },
    // 页面逆时针翻转90度。
    counterClock() {
      this.pageRotate -= 90;
    },
    // 页面加载回调函数，其中e为当前页数
    pageLoaded(e) {
      this.curPageNum = e;
    },
    // 其他的一些回调函数。
    pdfError(error) {
      console.error(error);
    },

    //放大
    scaleD() {
      this.scale += 5;
      this.$refs.wrapper.$el.style.width = parseInt(this.scale) + "%";
    },

    //缩小
    scaleX() {
      if (this.scale == 100) {
        return;
      }
      this.scale += -5;
      this.$refs.wrapper.$el.style.width = parseInt(this.scale) + "%";
    },
  },
  beforeRouteEnter(to, from, next) {
    // 路由守卫刚刚进入是没有实例化界面的，不能使用this
    const queryParam = to.query;
    console.log(queryParam);
    next((vm) => {
      vm.src = pdf.createLoadingTask(queryParam.url);
      vm.src.promise.then((pdf) => {
        vm.numPages = pdf.numPages;
      });
    });
  },
};
</script>

<style lang="scss" scoped>
.page {
  text-align: center;
}
.button {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.mr10 {
  margin: 0.1rem;
}
.icon-button-a {
  position: fixed;
  bottom: 1.4rem;
  right: 0.2rem;
  .icon-button {
    width: 0.8rem;
  }
}
</style>


